export const writerRoles = {
  assistant: 'assistant',
  system: 'system',
  user: 'user',
}

export function isAssistant(role: string): boolean {
  return (role === writerRoles.assistant);
}
